export default "__VITE_ASSET__Q5iV3OjV__"